import request from '@/libs/request'

// 牛场繁育记录 列表
export function cattleBreedLogListApi (data) {
  return request({
    url: `cattleFarm/cattleBreedLog`,
    method: 'get',
    params: data
  })
}

// 牛场繁育记录 详情
export function cattleBreedLogDetailApi (id) {
  return request({
    url: `cattleFarm/cattleBreedLog/` + id,
    method: 'get'
  })
}


// 牛场繁育记录 编辑/添加
export function cattleBreedLogSaveApi (data) {
  return request({
    url: `cattleFarm/cattleBreedLog`,
    method: 'post',
    data: data
  })
}

// 牛场繁育记录 删除
export function cattleBreedLogDelApi (id) {
  return request({
    url: `cattleFarm/cattleBreedLog/` + id,
    method: 'delete'
  })
}


